export default __webpack_public_path__ + "static/media/kitchen5-afterA-1440w.054cab2e.png";